/**
 * 标准及定制页面底层水印
 */

let waterItemDOM = '';
const cusCreateWatermark = config => {
  console.log('---------------------mark');
  const contentDOM = document.getElementById('content');
  if (waterItemDOM === '') {
    const { watermark_intervalWidth, watermark_intervalheight, style, textContent } = config;
    const { clientHeight: contentHeight, clientWidth: contentWidth } = contentDOM;
    const { listNumber, rowNumber } = {
      listNumber: Math.floor((contentHeight - 30) / watermark_intervalheight),
      rowNumber: Math.floor((contentWidth - 20) / watermark_intervalWidth)
    };
    // 生成水印
    let waterStyle = [];
    for (let key in style) {
      waterStyle.push(`${key}:${style[key]}`);
    }
    waterItemDOM = '';
    let fragment = document.createDocumentFragment()
    for (let listI = 0; listI < listNumber; listI++) {
      for (let rowI = 0; rowI < rowNumber; rowI++) {
        /**
          * 频繁插入DOM，消耗性能大，故被注释
          let domStyle = waterStyle.join(';');
          let waterDOM = document.createElement('div');
          waterDOM.style = `${domStyle};left: ${ 20 + (rowI * watermark_intervalWidth) }px;top: ${ 30 + (listI * watermark_intervalheight) }px;`;
          waterDOM.innerHTML = `<div>${ textContent }</div>`
          contentDOM.firstChild.appendChild(waterDOM);
        */
        const domStyle = `${waterStyle.join(';')};left: ${20 + (rowI * watermark_intervalWidth)}px;top: ${30 + (listI * watermark_intervalheight)}px;`;
        // waterItemDOM += `<div class="page-watermark-item" style="${domStyle}"><div>${textContent}</div></div>`;
        let waterDOM = document.createElement('div');
        waterDOM.className = 'page-watermark-item';
        waterDOM.style = domStyle
        waterDOM.innerHTML = `${textContent}`
        fragment.appendChild(waterDOM) // 暂存的虚拟dom
      }
    }
    // waterDOM.className = 'page-watermark';
    contentDOM.firstChild.appendChild(fragment)
  }
  // const waterDOM = document.createElement('div');
  // waterDOM.className = 'page-watermark';
  // waterDOM.style = 'position: fixed;top: 93px;width: calc(100% - 238px);height: calc(100% - 105px);pointer-events: none;z-index: 9999;';
  // waterDOM.innerHTML = waterItemDOM;
  // contentDOM.firstChild.appendChild(waterDOM);
}


function createWatermark(object) {
  const defaultSettings = {
    textContent: ['请设置水印显示文字'], // 每行显示的文本内容
    watermark_intervalWidth: 100, //  间隔宽度
    watermark_intervalheight: 100, // 间隔高度
    style: {
      webkitTransform: 'rotate(-25deg)',
      MozTransform: 'rotate(-25deg)',
      msTransform: 'rotate(-25deg)',
      OTransform: 'rotate(-25deg)',
      transform: 'rotate(-25deg)',
      visibility: '',
      position: 'absolute',
      overflow: 'hidden',
      zIndex: '9999',
      pointerEvents: 'none', // pointer-events:none  让水印不阻止交互事件
      opacity: 0.15,
      fontSize: '14px',
      fontFamily: '微软雅黑',
      color: '#575757',
      textAlign: 'left',
      width: '200px',
      height: '30px',
      display: 'block',
    }
  };

  const mark_divs = document.getElementsByClassName('mark_div');
  const pageFlag = vm.$route.fullPath == "/" || vm.$route.meta.routePrefix == "/CUSTOMIZED" // 欢迎页 || 定制页面

  if (mark_divs.length > 0) {
    for (let i = mark_divs.length - 1; i >= 0; i--) {
      if (pageFlag) {
        document.querySelector('#content').removeChild(mark_divs[i]);
      } else {
        document.body.removeChild(mark_divs[i]);
      }
    }
  }
  const setting = Object.assign({}, defaultSettings, object);
  const _temp = document.createDocumentFragment();
  const dom = setting.id ? document.querySelector(`#${setting.id}`) : document.querySelector('#content') // document.body.appendChild(_temp);
  // console.log(333, dom.offsetHeight);
  const maxWidth = dom.offsetWidth;
  const maxHeight = dom.offsetHeight;
  const rowNumber = Math.floor((maxWidth - 40 - 40) / setting.watermark_intervalWidth); // 横向个数
  const coumnNumber = Math.floor((maxHeight) / setting.watermark_intervalheight); // 纵向个数


  for (let i = 0; i < rowNumber; i++) {
    for (let j = 0; j < coumnNumber; j++) {
      const x = setting.watermark_intervalWidth * i + 20;
      const y = setting.watermark_intervalheight * j + 10;
      const mark_div = document.createElement('div');
      mark_div.id = `mark_div${i}${j}`;
      mark_div.className = 'mark_div';
      Object.assign(mark_div.style, setting.style);
      mark_div.style.left = `${x}px`;
      mark_div.style.top = `${y}px`;
      setting.textContent.forEach((element) => {
        const span0 = document.createElement('div');
        span0.appendChild(document.createTextNode(element));
        mark_div.appendChild(span0);
      });

      _temp.appendChild(mark_div);
    }
  }
  const tpl = dom;
  tpl.appendChild(_temp);
};
function getConfig() {
  const _this = vm
  const userInfo = JSON.parse(window.localStorage.getItem('userInfo')) || _this.userInfo;
  let myDate = new Date();
  let currentDate = `${myDate.getFullYear()}/${myDate.getMonth() + 1}/${myDate.getDate()} ${myDate.getHours()}:${myDate.getMinutes()}:${myDate.getSeconds()}`

  const text = `${userInfo.name} ${userInfo.ename} ${currentDate}`;
  console.log(text);
  const object = {
    id: _this.$router.currentRoute.params.tableName,
    textContent: [text], // 每行显示的文本内容
    watermark_intervalWidth: 100, //  间隔宽度
    watermark_intervalheight: 100, // 间隔高度
    style: {
      webkitTransform: 'rotate(-25deg)',
      MozTransform: 'rotate(-25deg)',
      msTransform: 'rotate(-25deg)',
      OTransform: 'rotate(-25deg)',
      transform: 'rotate(-25deg)',
      visibility: '',
      position: 'absolute',
      // overflow: 'hidden',
      zIndex: '9999',
      pointerEvents: 'none', // pointer-events:none  让水印不阻止交互事件
      opacity: 0.15,
      fontSize: '14px',
      fontFamily: '微软雅黑',
      color: '#ccc',
      textAlign: 'left',
      width: '140px',
      height: '30px',
      display: 'block',
      display: '-webkit-box',
      webkitBoxOrient: 'vertical',
      webkitLineClamp: 2,

      // left: '10px',//不支持设置定位，
      // top: '10px',
    }
  };
  return object
}
export function standMarkMixin() {
  return {
    mounted() {
      const _this = vm
      _this.$nextTick(() => {
        // _this.$createWatermark(getConfig()); // 标准页面
      });
    },
  }
}

export function cusMark() {
  setTimeout(() => {
    // createWatermark(getConfig()) // 定制页面
  }, 100);
}
